const confirmationModal = () => ({
    showingModal: false,
    title: null,
    body: null,
    confirmButtonClasses: null,
    callback: null,
    openModal(eventDetail) {
        this.title = eventDetail.title || 'Are you sure?'
        this.body = eventDetail.body || 'Are you sure you\'d like to proceed?'
        this.confirmButtonClasses = eventDetail.confirmButtonClasses || 'bg-red-600 text-white border-red-600'
        this.callback = eventDetail.callback || null

        this.toggleModal()
    },
    runCallback() {
        this.callback()
        this.toggleModal()
    },
    toggleModal() {
        window.Alpine.store('general').showOverlay = !window.Alpine.store('general').showOverlay
        this.showingModal = !this.showingModal
    },
})
document.addEventListener('alpine:init', () => {
    window.Alpine.data('confirmationModal', confirmationModal)
})
